// common-ui/components/EditableTimer.tsx
import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  },
  timerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  input: {
    width: 60,
    textAlign: 'center'
  },
  colon: {
    fontSize: 20,
    fontWeight: 600
  }
}));

/**
 * Reusable Editable Timer component
 * Displays two inputs (HH:MM) and calls handlers when either changes.
 */
export const EditableTimer = ({
  hour,
  minute,
  onHourChange,
  onMinuteChange,
  label = 'Edit Time',
  disabled = false
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.container
  }, label && /*#__PURE__*/React.createElement(FormHelperText, null, label), /*#__PURE__*/React.createElement(Box, {
    className: classes.timerRow
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "HH",
    variant: "outlined",
    value: hour,
    onChange: e => onHourChange(e.target.value),
    inputProps: {
      maxLength: 2,
      style: {
        textAlign: 'center'
      }
    },
    className: classes.input,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(Typography, {
    className: classes.colon
  }, ":"), /*#__PURE__*/React.createElement(TextField, {
    label: "MM",
    variant: "outlined",
    value: minute,
    onChange: e => onMinuteChange(e.target.value),
    inputProps: {
      maxLength: 2,
      style: {
        textAlign: 'center'
      }
    },
    className: classes.input,
    disabled: disabled
  })));
};
export default EditableTimer;